import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface AdminLists {
    loading: boolean;
    systemCompanyId: number;
    canUpdateReckonFilename: boolean;
    canUploadSystemFiles: boolean;
    canViewUpdatePricelists: boolean;
    canEditTrucks: boolean;
    canEditPublicHols: boolean;
    canEditItems: boolean;
    error: string;
}

export class AdminListData extends React.Component<RouteComponentProps<{}>, AdminLists> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            systemCompanyId: 2,
            canUpdateReckonFilename: false,
            canUploadSystemFiles: false,
            canEditItems: false,
            canEditPublicHols: false,
            canEditTrucks: false,
            canViewUpdatePricelists: false,
            error: ""
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=CreateEditAdminLists&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                axios.get('api/User/GetUserSystemCompanyId?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ loading: false, systemCompanyId: res.data });
                    this.checkReckonPermission(token ?? "", user.sub);
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    checkReckonPermission = async (token: string, subId: string) => {
        axios.get('api/User/CheckAdminPermission?SubId=' + subId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({
                canUpdateReckonFilename: res.data.canUpdateReckonFileName,
                canUploadSystemFiles: res.data.canUploadSystemFiles,
                canEditItems: res.data.canEditItems,
                canEditPublicHols: res.data.canEditPublicHols,
                canEditTrucks: res.data.canEditTrucks,
                canViewUpdatePricelists: res.data.canViewUpdatePricelists
            });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFile = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importDrumsData(files);
    }

    async importDrumsData(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);
        
        axios('api/Admin/ImportDrumsPowerPoles', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileToilets = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importDrumsDataToilets(files);
    }

    async importDrumsDataToilets(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsToilets', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Toilet Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFilePump = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importDrumsDataPump(files);
    }

    async importDrumsDataPump(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsPumpAndCleans', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
            .then(res => {
                //DOWNLOAD FILE TO BROWSER
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Drums Failed Import Pump and Clean Jobs.csv');
                document.body.appendChild(link);
                link.click();
                toast.success("Drums data pump and cleans imported into Dash successfully!");
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    handleImportFileTempFence = (e: any) => {
        var files = e.target.files[0];
        this.importDrumsDataTempFence(files);
    }

    importDrumsDataTempFence = async (file: File) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsTempFenceJobs', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import 1300 Temp Fence Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data 1300 Temp Fence imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileShowers = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importDrumsDataShowers(files);
    }

    async importDrumsDataShowers(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsShowers', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Shower Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Showers imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileCrossovers = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importDrumsDataCrossovers(files);
    }

    async importDrumsDataCrossovers(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsCrossovers', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Crossover Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Crossovers imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileCages = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importDrumsDataCages(files);
    }

    async importDrumsDataCages(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsRubbishCages', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Rubbish Cage Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Rubbish Cages imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileFencing = (e: any) => {
        var files = e.target.files[0];
        this.importDrumsDataFencing(files);
    }

    async importDrumsDataFencing(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsFencing', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Fencing Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Fencing imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileSiltBarriers = (e: any) => {
        var files = e.target.files[0];
        this.importDrumsDataSiltBarriers(files);
    }

    async importDrumsDataSiltBarriers(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsSiltBarriers', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Silt Barriers Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Silt Barriers imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileFenceReinstate = (e: any) => {
        var files = e.target.files[0];
        this.importDrumsDataFenceReinstate(files);
    }

    async importDrumsDataFenceReinstate(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsFenceReinstate', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Fence Reinstate Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Fence Reinstate imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileFencePartPickup = (e: any) => {
        var files = e.target.files[0];
        this.importDrumsDataFencePartPickup(files);
    }

    async importDrumsDataFencePartPickup(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsFencePartPickup', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Fence Part Pickup Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Fence Part Pickup imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileFenceBTMSimonds = (e: any) => {
        var files = e.target.files[0];
        this.importDrumsDataFenceBTMSimonds(files);
    }

    async importDrumsDataFenceBTMSimonds(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsFencingBTMSimonds', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Fence BTM Simonds Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Fence BTM Simonds imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFileFenceBTM = (e: any) => {
        var files = e.target.files[0];
        this.importDrumsDataFenceBTM(files);
    }

    async importDrumsDataFenceBTM(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsFencingBTM', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Fence BTM Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Fence BTM imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportFilePickups = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importDrumsDataPickups(files);
    }

    async importDrumsDataPickups(file: File) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportDrumsPickups', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Pickup Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Drums data Pickups imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportCustomers = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importCustomers(files);
    }

    importCustomers = async (file: File) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportCustomers', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Customers.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Customers imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleImportRentABathroom = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importRentABathroomJobs(files);
    }

    importRentABathroomJobs = async (file: File) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/ImportRentABathroomJobs', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Drums Failed Import Rent A Bathroom Jobs.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Rent A Bathroom Jobs imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    handleCreateRabPthExtraInitialInvoices = (e: any) => {
        var files = e.target.files[0];
        //this.setState({ uploadedFiles: e.target.files });
        this.importExtraInitialInvoices(files);
    }

    importExtraInitialInvoices = async (file: File) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //import jobs from drums
        const data = new FormData()

        data.append('subId', user.sub);
        data.append('csvFile', file);

        axios('api/Admin/CreateExtraInitialInvoices', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'POST',
            data: data,
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Failed Import Extra Initial Invoices.csv');
            document.body.appendChild(link);
            link.click();
            toast.success("Extra Initial Invoices imported into Dash successfully!");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

   

    updateEventCustomers = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        this.setState({ error: "" });

        var data = {
            subId: user.sub
        };

        axios.post('api/Job/UpdateEventCustomerDetails', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Event Customers details updated successfully");
        })
        .catch(error => {
            this.setState({ error: error.message });
            toast.error(error.message);
        });
    }

    handleCustomerUpdateScaffold = (e: any) => {
        e.preventDefault();
        toast.info("Running Scaffold Customers");
        this.updateCustomers(2);
    }

    handleCustomerUpdateDunny = (e: any) => {
        e.preventDefault();
        toast.info("Running Dunny Customers");
        this.updateCustomers(3);
    } 

    updateCustomers = async (companyId: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        this.setState({ error: "" });

        //enter the page that reckon needs to return to, id blank as not used via invoicing
        var page = {
            page: "adminlists",
            id: 0
        };
        //encode to base 64 so can retrieve it later
        var encoded = window.btoa(JSON.stringify(page));

        axios.get('api/Customer/ReckonCustomerAuthoriseCheck?returnUrl=' + encoded + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //continue if Quick Books user is authorised
            if (res.data.isAuthorised) {
                this.linkCustomersToReckon(token ?? "", user.sub, companyId)
            } else if (!res.data.reckonSwitchedOn) {
                //need to have reckon switched on to update customers
                toast.error("Reckon isn't switched on!");
            } else {
                window.location.replace(res.data.reckonLoginUrl)
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    linkCustomersToReckon = async (token: string, subId: string, companyId: number) => {
        var data = {
            subId: subId,
            companyId: companyId
        };

        axios.post('api/Customer/LinkCustomersToReckon', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Customers Linked to Reckon Successfully");
        })
        .catch(error => {
            this.setState({ error: error.message });
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
        <h1>Admin Lists</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        
        return (
            <div>
                <div className={this.state.canViewUpdatePricelists ? "" : "hidden"}>
                    <div className={this.state.systemCompanyId === 2 ? "hidden" : "adminlists__item"}>
                        <NavLink to={'/pricelistsetweeks'} exact activeClassName='active'>
                            Price List Set Weeks
                        </NavLink>
                    </div>
                    <div className="adminlists__item">
                        <NavLink to={'/pricelists'} exact activeClassName='active'>
                            {this.state.systemCompanyId === 2 ? "Price Lists" : "Price List - EWS / Site Building"}
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistkwikstage'} exact activeClassName='active'>
                            Price List - Kwikstage
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelisttowers'} exact activeClassName='active'>
                            Price List - Towers
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistepa'} exact activeClassName='active'>
                            Price List - EPA
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistpumpclean'} exact activeClassName='active'>
                            Price List - Pump & Cleans / Relocate Toilet/Power Pole
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistfencing'} exact activeClassName='active'>
                            Price List - Fencing
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistfencingcustom'} exact activeClassName='active'>
                            Price List - Fencing Custom
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistevent'} exact activeClassName='active'>
                            Price List - Events
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistcustom'} exact activeClassName='active'>
                            Price List - Custom
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/pricelistpowerpoleconnection'} exact activeClassName='active'>
                            Price List - Power Pole Connections
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/surcharges'} exact activeClassName='active'>
                            Surcharges
                        </NavLink>
                    </div>
                    <div className = "adminlists__item">
                        <NavLink to={'/pricelistsettings'} exact activeClassName='active'>
                            {this.state.systemCompanyId === 3 ? "Cleaning, Travel, Power Pole Fees" : "Travel, Labour etc Rates"}
                        </NavLink>
                    </div>
                </div>
                <div className={this.state.canEditPublicHols ? "" : "hidden"} >
                    <div className={this.state.systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/publicholidays'} exact activeClassName='active'>
                            Public Holidays
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/shutdownperiods'} exact activeClassName='active'>
                            Shutdown Periods
                        </NavLink>
                    </div>
                </div>
                <div className={this.state.canEditItems ? "" : "hidden"} >
                    <div className={this.state.systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/itemformulas'} exact activeClassName='active'>
                            Item Formulas
                        </NavLink>
                    </div>
                    <div className={this.state.systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                        <NavLink to={'/itemphoto'} exact activeClassName='active'>
                            Item Photo
                        </NavLink>
                    </div>
                </div>
                <div className={this.state.canEditTrucks ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/trucks'} exact activeClassName='active'>
                        Trucks
                    </NavLink>
                </div>
                <div className={this.state.canUploadSystemFiles && this.state.systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/systemfiles'} exact activeClassName='active'>
                        Upload System Files
                    </NavLink>
                </div>
                <div className={this.state.canUpdateReckonFilename ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reckondata'} exact activeClassName='active'>
                        Update Reckon Filename/s
                    </NavLink>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Showers CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileShowers}></input>
                    </div>
                </div>
                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <div>Import Toilets before Crossovers to cater for BTC jobs</div>
                        <span className="marginRight10">Upload Drums Data - Toilets CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileToilets}></input>
                    </div>
                </div>
                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Crossovers CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileCrossovers}></input>
                    </div>
                </div>
                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Rubbish Cages CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileCages}></input>
                    </div>
                </div>
                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Pump & Cleans CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFilePump}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - 1300 Temp Fence CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileTempFence}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Fencing CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileFencing}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Silt Barriers CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileSiltBarriers}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Fence Reinstate CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileFenceReinstate}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Fence Part Pickup CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileFencePartPickup}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Fence BTM Simonds CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileFenceBTMSimonds}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Fence BTM CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFileFenceBTM}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Upload Drums Data - Pickups CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportFilePickups}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Import Customers CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportCustomers}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Import Rent a Bathroom CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleImportRentABathroom}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <span className="marginRight10">Import RAB/PTH Extra Invoices CSV</span> <input type="file" name="file" accept=".csv" onChange={this.handleCreateRabPthExtraInitialInvoices}></input>
                    </div>
                </div>

                <div className={this.state.systemCompanyId === 2 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <a href="#" className="marginRight10" onClick={(e) => this.handleCustomerUpdateScaffold(e)}>Link Dash Customers to Reckon Scaffold</a>
                    </div>
                </div>
                <div className={this.state.systemCompanyId === 3 ? "hidden" : "hidden"}>
                    <div className="marginTop10">
                        <a href="#" className="marginRight10" onClick={(e) => this.handleCustomerUpdateDunny(e)}>Link Dash Customers to Reckon Dunny</a>
                    </div>
                    <div>{this.state.error}</div>
                </div>
            </div>
        );

    }

};